import { SubtaskStatus } from '@webapp/account/src/resources/tasks/task';

import css from './task-waiting.css';

const mapStatusToMessage = (status: SubtaskStatus): string => {
    switch (status) {
        case SubtaskStatus.WAITING:
            return 'В очереди';
        case SubtaskStatus.COMPLETE:
            return 'Готово';
        default:
            return 'Формирование';
    }
};

export const TaskWaiting: FC<{
    progressPercent: number;
    status: SubtaskStatus;
}> = ({ progressPercent, status }) => {
    const msg = mapStatusToMessage(status);
    const progressStyle = {
        width: `${progressPercent}%`,
    };

    return (
        <div className={css.loading}>
            <div className={css.left}>
                <div className={css.label}>{msg}</div>
                <div className={css.progressBg}>
                    <div className={css.progress} style={progressStyle}>
                        <div className={css.bar} />
                    </div>
                </div>
            </div>
            <div className={css.label}>{`осталось ${100 - progressPercent}%`}</div>
        </div>
    );
};
